import { storage, tokenKeyName } from '@/setting.config'

/**
 * 获取accessToken
 * @returns
 */
export function getAccessToken() {
  if ('localStorage' === storage) {
    return localStorage.getItem(tokenKeyName)
  } else if ('sessionStorage' === storage) {
    return sessionStorage.getItem(tokenKeyName)
  } else {
    return localStorage.getItem(tokenKeyName)
  }
}

/**
 * 存储accessToken
 * @param {*} accessToken
 * @returns
 */
export function setAccessToken(accessToken) {
  if ('localStorage' === storage) {
    return localStorage.setItem(tokenKeyName, accessToken)
  } else if ('sessionStorage' === storage) {
    return sessionStorage.setItem(tokenKeyName, accessToken)
  } else {
    return localStorage.setItem(tokenKeyName, accessToken)
  }
}

/**
 * 移除accessToken
 * @returns
 */
export function removeAccessToken() {
  if ('localStorage' === storage) {
    return localStorage.removeItem(tokenKeyName)
  } else if ('sessionStorage' === storage) {
    return sessionStorage.removeItem(tokenKeyName)
  } else {
    return localStorage.removeItem(tokenKeyName)
  }
}
